/**
 * DetailButtons component.
 */
import Container from '@components/atoms/container/detailButtonsContainer';
import List from '@components/sections/list/list';
import useDetailButtons from '@shared/components/utils/hooks/useDetailButtons';

/**
 * Displays the detail buttons section.
 */
export default function DetailButtons() {
  const { buttons, callbacks, props } = useDetailButtons();
  return (
    <Container {...callbacks.container} {...props.buttons} id={'detailButtons'}>
      <List {...callbacks.list} {...props.list}>
        {buttons?.map((item, index) => {
          const { Button } = item;
          return <Button key={index} index={index} {...item} />;
        })}
      </List>
    </Container>
  );
}
